import Dashboard from "./dashboard/Dashboard"

function HomePage() {
  return <Dashboard />
}

export default HomePage
